/* LP controls only. Native cart remains untouched. User rollback 2026-09-29. */
(() => {
  'use strict';
  if (window.CM014BuyV4) { window.CM014BuyV4.init(); return; }
  const states = new Map();
  let api, pending;
  const find = (s,q) => s.root.querySelector(q);
  const form = s => find(s,'[data-cm014-form]');
  const stop = e => { e.preventDefault(); e.stopImmediatePropagation(); };
  const text = (n,t) => { if(n && n.textContent !== t) n.textContent=t; };
  const emit = (name,detail) => document.dispatchEvent(new CustomEvent('cm014-buy:'+name,{detail}));
  function track(root) {
    root.querySelectorAll('[data-cm014-details]').forEach(a => {
      const u = new URL('https://www.try-chinology.com/pages/chino-mask');
      new URL(location.href).searchParams.forEach((v,k) => {
        if (/^(utm_.+|fbclid|gclid|ttclid|tw_.+|ad_id|adset_id|campaign_id|srsltid)$/i.test(k)) u.searchParams.append(k,v);
      });
      a.href=u.href;
    });
  }
  function error(s,message) { const n=find(s,'[data-cm014-error]'); text(n,message); if(n)n.hidden=!message; }
  function refresh(s) {
    if (!s.root.isConnected || !form(s)) return;
    bindCart();
    let valid=false;
    try {
      const w=find(s,'kaching-bundle'), b=w?.querySelector('kaching-bundles-block'), items=b?.items?.();
      valid = w?.dataset.initialized==='true' && Array.isArray(items) && items.some(i=>!i.parent_id) &&
        b.validateItemSelection?.()?.valid !== false && b.querySelector('.kaching-bundles__bar--selected > input[type="radio"]')?.checked;
    } catch (_) {}
    s.ready=Boolean(api && valid && s.root.dataset.cm014Available==='true');
    const button=find(s,'[data-cm014-submit]');
    button.disabled=!s.ready || Boolean(pending) || Date.now()<(s.cooldown||0);
    button.setAttribute('aria-disabled',String(button.disabled)); button.setAttribute('aria-busy',String(pending===s));
    if(!pending && !s.added) text(find(s,'[data-cm014-status]'),s.ready?'':'Loading available offers…');
    s.root.querySelectorAll('.kaching-bundles__bar').forEach(bar=>{
      if(!/^3 Masks?$/i.test(bar.querySelector('.kaching-bundles__bar-title')?.textContent?.trim()||''))return;
      // Presentation only: leave app config, wrappers and listeners intact.
      bar.querySelectorAll('.kaching-bundles__bar-most-popular__content,[class*="badge"]').forEach(badge=>{
        if(!/^popular$/i.test(badge.textContent.trim()))return;
        const walker=document.createTreeWalker(badge,NodeFilter.SHOW_TEXT);
        let n=walker.nextNode(); if(n)n.nodeValue='Most Popular'; while((n=walker.nextNode()))n.nodeValue='';
      });
    });
    s.root.querySelectorAll('.kaching-bundles__progressive-gifts__subtitle').forEach(subtitle=>{
      // Copy only: preserve Kaching's DOM anchors and gift/price configuration.
      const walker=document.createTreeWalker(subtitle,NodeFilter.SHOW_TEXT);
      let node;while((node=walker.nextNode())){
        if(node.nodeValue.includes('$50 VALUE OF FREE GIFTS FOR TODAY ONLY'))node.nodeValue=node.nodeValue.replace('$50 VALUE OF FREE GIFTS FOR TODAY ONLY','$50 VALUE OF FREE ANNIVERSARY GIFTS');
      }
    });
  }
  function refreshAll(){states.forEach(refresh);}
  // b0_kaching_garde v9 + v6: selected pack stays selected, nested controls work.
  function selectedTarget(e,s) {
    const t=e.target instanceof Element?e.target:null, bar=t?.closest('.kaching-bundles__bar--selected');
    if(!bar || !s.root.contains(bar))return false;
    const radio=bar.querySelector(':scope > input[type="radio"]'), main=t.closest('.kaching-bundles__bar-main');
    if(!radio?.checked || (!main && t!==radio))return false;
    const control=t.closest('input,select,textarea,button,a,[role="button"],[role="checkbox"],[role="radio"],[role="combobox"],[contenteditable="true"]');
    if(control && control!==main && control!==radio)return false;
    const label=t.closest('label');return !label?.control || label.control===radio;
  }
  function bindCart() {
    const next=window.liquidAjaxCart;
    if(next===api || typeof next?.subscribeToCartAjaxRequests!=='function' || typeof next.getCartState!=='function')return;
    api=next;
    api.subscribeToCartAjaxRequests((request,subscribe)=>{
      const s=[...states.values()].find(s=>request.info?.initiator===s.submittedForm || request.info?.initiator===form(s));
      if(request.requestType!=='add'||!s)return;
      s.requestSeen=true;
      subscribe(result=>{
        clearTimeout(s.timer);const response=result.responseData;
        if(response?.ok && !result.info?.cancel) {
          pending=null;s.added=true;s.cooldown=Date.now()+3000;
          error(s,'');text(find(s,'[data-cm014-status]'),'Added to your cart.');
          document.dispatchEvent(new Event('sidecart:open'));
          setTimeout(refreshAll,3100);emit('added',{instance:s.instance});
        } else {
          // Ambiguous request stays locked: do not repeat a possibly successful add.
          if(result.info?.cancel || (response?.status>=400 && response.status<500))pending=null;
          error(s,response?.status===429?'Too many attempts. Wait a moment and check your cart before trying again.':'We could not confirm the addition. Check your cart before trying again.');
        }
        find(s,'[data-cm014-cart]').hidden=false;refreshAll();
      });
    });
  }
  function init() {
    document.querySelectorAll('[data-cm014-buy]').forEach(root=>{
      track(root);if(root.dataset.cm014Bound)return;
      const instance=root.dataset.cm014Buy;
      if(states.has(instance)&&states.get(instance).root.isConnected){root.querySelectorAll('button').forEach(b=>b.disabled=true);emit('incompatible',{instance,reason:'duplicate-instance'});return;}
      if(!root.querySelector('[data-cm014-form]'))return;
      const s={root,instance};states.set(instance,s);root.dataset.cm014Bound='true';
      root.addEventListener('submit',e=>{
        if(e.target!==form(s))return;
        refresh(s);
        if(!s.ready||pending||Date.now()<(s.cooldown||0)){stop(e);return;}
        pending=s;s.submittedForm=e.target;s.requestSeen=false;
        error(s,'');text(find(s,'[data-cm014-status]'),'Adding your selected offer…');
        // Disable only after native dispatch; never replay or manufacture a submit.
        setTimeout(refreshAll,0);
        s.timer=setTimeout(()=>{if(pending!==s)return;error(s,'Your cart is taking longer than expected. Check your cart before trying again.');find(s,'[data-cm014-cart]').hidden=false;emit('incompatible',{instance,reason:s.requestSeen?'request-timeout':'missing-lac-owner'});},20000);
      },true);
      root.addEventListener('click',e=>{if(selectedTarget(e,s))stop(e);},true);
      root.addEventListener('keydown',e=>{if(['Enter',' '].includes(e.key)&&selectedTarget(e,s))stop(e);},true);
      let scheduled=false;
      const schedule=()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;refresh(s);});};
      new MutationObserver(records=>{
        if(records.some(r=>(r.target instanceof Element?r.target:r.target.parentElement)?.closest('kaching-bundle') || [...r.addedNodes].some(n=>n.nodeType===1&&(n.matches('[data-cm014-form]')||n.querySelector('[data-cm014-form]')))))schedule();
      }).observe(root,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['data-initialized','value','aria-checked','class']});
      root.addEventListener('change',schedule);root.addEventListener('variants-changed',schedule,true);
      setTimeout(()=>{refresh(s);if(!s.ready){error(s,'The offers could not load. Open the product details below.');emit('incompatible',{instance,reason:'offer-not-ready'});}},15000);
      refresh(s);
    });bindCart();
  }
  document.addEventListener('liquidAjaxCartInit',()=>{init();refreshAll();});
  window.addEventListener('kaching-bundles-initialized',refreshAll);
  document.addEventListener('shopify:section:load',init);
  window.CM014BuyV4=Object.freeze({init});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();

